import APP_CONSTANTS from '@/config/constants';
import { globalState } from '@/state/globalState';
import { databaseService } from '@/services/databaseService';
import { supabase } from '@/services/supabase';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { v4 as uuidv4 } from 'uuid';
import { pullRemoteChanges, pushLocalChanges } from '@/services/syncService';
import { getSyncClientBuild, syncCanaryFeatureDecisionStore, SyncCanaryFeatureService } from '@/services/sync/SyncCanaryFeatureService';
import { ChecklistTransferService, createChecklistTransferOperationStore, type ChecklistTransferRpcArgs } from './ChecklistTransferService';
const operationStore = createChecklistTransferOperationStore(AsyncStorage, uuidv4);
const transferFeatureService = new SyncCanaryFeatureService({
  async isEnabled(input) {
    const { data, error } = await supabase.rpc('app_guincho_feature_enabled_v1', {
      p_empresa_id: input.companyId,
      p_feature_key: input.featureKey,
      p_client_build: input.clientBuild,
    });
    if (error) throw error;
    return data === true;
  },
}, true, syncCanaryFeatureDecisionStore);

export const checklistTransferService = new ChecklistTransferService({
  database: databaseService,
  isOnline: () => globalState.network.isConnected.get(),
  getClientBuild: getSyncClientBuild,
  isFeatureEnabled: input => transferFeatureService.isEnabled(input.companyId, input.featureKey, input.clientBuild),
  pushLocalChanges: async () => pushLocalChanges({ tracePrefix: '[checklist-transfer]' }),
  refreshChecklist: async () => pullRemoteChanges({
    tables: [APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CHECKLISTS.NAME],
    skipPush: true,
    tracePrefix: '[checklist-transfer-refresh]',
  }),
  getOrCreateOperationId: operationStore.getOrCreateOperationId,
  findOperation: operationStore.findOperation,
  clearOperationId: operationStore.clearOperationId,
  listCandidates: async (args) => {
    const { data, error } = await supabase.rpc('list_checklist_transfer_candidates_v1', args);
    if (error) throw error;
    return data;
  },
  callRpc: async (args: ChecklistTransferRpcArgs) => {
    const { data, error } = await supabase.rpc('transfer_checklist_owner_v1', args);
    if (error) throw error;
    return data;
  },
  checklistTable: APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CHECKLISTS.NAME,
});
